export default __webpack_public_path__ + "static/media/2_0128.69f2d500.webp";